<template>
  <v-dialog v-model="dialog" persistent max-width="630px" max-height="965px">
    <v-card id="tbMeetingEditDialog">
      <div class="dialog-container">
        <div class="dialog-header">
          <div style="display: flex; flex-direction: row; align-items: center;">
            <h3 class="header-title">영상회의 수정</h3>
            <div
              class="meetingType-btn"
              v-show="meetingTypeBtn === 'open'"
              style="width: 110px; height: 40px; line-height: 40px; padding: 0; text-align: center;"
            >
              {{ meetingTypeTxt }}
            </div>
          </div>
          <img
            @click="openDeleteConfirmDialog('del')"
            src="../../../src/images/button/delBtn.png"
            style="margin-right:30px; cursor: pointer;"
          />
        </div>
        <div class="dialog-body">
          <div class="dialog-row">
            <div class="dialog-title">
              <div class="dot-btn">&nbsp;</div>
              <div class="pl-2">제목</div>
            </div>
            <div class="dialog-contents">
              <input
                type="text"
                style="font-size:15px;"
                placeholder="필수 입력"
                v-model="editedMeetingInfo.title"
                :disabled="meetingTypeFixed"
              />
            </div>
          </div>
          <div class="dialog-line-flex">
            <div class="dialog-hr-line"></div>
          </div>
          <div class="dialog-row">
            <div class="dialog-title">
              <div class="dot-btn">&nbsp;</div>
              <div class="pl-2">일시</div>
            </div>
            <div class="dialog-date-contents" style="position: relative">
              <input
                class="styled-checkbox"
                id="tbImmediateBtn"
                type="checkbox"
                style="z-index: 100; width: 100px; height: 30px; font-size:15px;"
                v-model="immediateMeeting"
                :disabled="meetingTypeFixed"
              />
              <label for="styled-checkbox-1" style="position: relative"
                >즉시회의</label
              >

              <date-picker
                :disabled-date="notBeforeToday"
                :disabled="meetingTypeFixed || isTimeFixed"
                v-model="editedMeetingInfo.selectStartTime"
                format="YYYY/MM/DD"
                value-type="format"
                :lang="lang"
                style="width: 140px; height: 40px; margin-left: 10px; margin-right: 15px; font-size: 13px;"
              ></date-picker>
              <select
                v-if="editedMeetingInfo.meetingType === 'video'"
                class="formbox-time-select"
                v-model="editedMeetingInfo.startTime"
                @change="changedstartTime"
                :disabled="
                  isTimeFixed ||
                    editedMeetingInfo.isImmediately ||
                    meetingTypeFixed
                "
                style="margin-right: 5px;"
              >
                <option
                  v-for="timeData in meetingTimeList"
                  :key="timeData"
                  :value="timeData"
                  >{{ timeData }}
                </option>
              </select>
              <span style="font-size: 12px; margin-right: 5px;">~</span>
              <select
                v-if="editedMeetingInfo.meetingType === 'video'"
                class="formbox-time-select"
                v-model="editedMeetingInfo.endTime"
                @change="changedendTime"
                :disabled="isTimeFixed || meetingTypeFixed"
              >
                <option
                  v-for="timeData in meetingTimeList"
                  :key="timeData"
                  :value="timeData"
                  >{{ timeData }}
                </option>
              </select>
              <select
                v-if="editedMeetingInfo.meetingType !== 'video'"
                class="formbox-time-select"
                v-model="editedMeetingInfo.startTime"
                @change="changedstartTime"
                :disabled="
                  isTimeFixed ||
                    editedMeetingInfo.isImmediately ||
                    meetingTypeFixed
                "
                style="margin-right: 5px;"
              >
                <option
                  v-for="timeData in meetingTimeList"
                  :key="timeData"
                  :value="editedMeetingInfo.startTime"
                  >{{ editedMeetingInfo.startTime }}
                </option>
              </select>
              <span
                style="font-size: 12px; margin-right: 5px;"
                v-if="editedMeetingInfo.meetingType !== 'video'"
                >~</span
              >
              <select
                v-if="editedMeetingInfo.meetingType !== 'video'"
                class="formbox-time-select"
                v-model="editedMeetingInfo.endTime"
                @change="changedendTime"
                :disabled="isTimeFixed || meetingTypeFixed"
              >
                <option
                  v-for="timeData in meetingTimeList"
                  :key="timeData"
                  :value="editedMeetingInfo.endTime"
                  >{{ editedMeetingInfo.endTime }}
                </option>
              </select>
            </div>
          </div>
          <div class="dialog-line-flex">
            <div class="dialog-hr-line"></div>
          </div>
          <div class="dialog-row">
            <div class="dialog-title">
              <div class="dot-btn">&nbsp;</div>
              <div class="pl-2">참석자</div>
            </div>
            <div class="dialog-public-contents">
              <input
                type="text"
                class="select-input cursor-pointer"
                style="font-size:15px; margin-left: 0;"
                placeholder="선택 사항"
                @click="openMeetingInvitaionDialog()"
                :value="attendeesString"
                readonly
              />
            </div>
          </div>
          <div class="dialog-line-flex">
            <div class="dialog-hr-line"></div>
          </div>
          <div class="dialog-row">
            <div class="dialog-title">
              <div class="dot-btn">&nbsp;</div>
              <div class="pl-2">레이아웃</div>
            </div>
            <div style="width: 78%; display: flex; align-items: center;">
              <input
                type="text"
                class="select-input cursor-pointer"
                style="font-size:15px; margin-left: 25px;"
                v-bind:style="{ display: isInputLayout }"
                @click="openMeetingLayoutDialog()"
                placeholder="선택사항"
                readonly
              />
              <img
                class="fix-layout-img"
                :src="layoutFixSeatList.selectedLayoutImage"
                v-bind:style="{ display: isLayout }"
                @click="openMeetingLayoutDialog()"
              />
            </div>
          </div>
          <div class="dialog-line-flex">
            <div class="dialog-hr-line"></div>
          </div>
          <div class="dialog-row">
            <div class="dialog-title">
              <div class="dot-btn">&nbsp;</div>
              <div class="pl-2">선택 옵션</div>
            </div>
            <div
              class="dialog-public-contents"
              style="flex-direction: column; align-items: start;"
            >
              <div
                style="position: relative; display: flex;  align-items: center;"
              >
                <input
                  type="checkbox"
                  id="video"
                  style="width: 150px; cursor:
                pointer; height: 25px;"
                  class="custom-radio conference-radio"
                  v-model="conferenceRoomActive"
                  :disabled="
                    meetingTypeFixed &&
                      conferenceRoomActive &&
                      editedMeetingInfo.meetingType === 'conf'
                  "
                />
                <label
                  class="custom-label conference-label"
                  style="position: relative;"
                  for="video"
                  >고화질 영상회의</label
                >

                <input
                  type="text"
                  class="select-input"
                  style="width:200px;
                font-size:12px; margin-left: 12px; padding-left: 10px;"
                  placeholder="선택사항"
                  :style="{ display: isRoomActive }"
                  :value="selectedConferenceRoomString"
                  @click="openMeetingConferenceDialog()"
                  readonly
                  
                  name="title"
                />
              </div>
              <div style="position: relative; margin-top: 8px;">
                <input
                  type="checkbox"
                  id="real"
                  class="custom-radio"
                  style="width: 150px; cursor: pointer; height: 24px;"
                  v-model="editedMeetingInfo.meetingLog"
                />
                <label class="custom-label" for="real">실시간 자막</label>
              </div>
              <div style="position: relative; margin-top: 8px;">
                <input
                  type="checkbox"
                  id="conference"
                  style="width: 150px; cursor: pointer; height: 24px;"
                  class="custom-radio"
                  v-model="editedMeetingInfo.allPublicMeeting"
                />
                <label class="custom-label" for="conference"
                  >전체 공개회의</label
                >
              </div>
              <div
                style="display:flex; align-items: center; position: relative; margin-top: 8px;"
              >
                <input
                  type="checkbox"
                  id="pw"
                  style="width: 100px; cursor: pointer; height: 25px;"
                  class="custom-radio conference-radio"
                  v-model="meetingPublicType"
                />
                <label
                  class="custom-label conference-label"
                  style="position: relative;"
                  for="pw"
                  >비밀번호</label
                >

                <input
                  :style="{ display: isPrivate }"
                  type="number"
                  placeholder="비밀번호를 입력하세요"
                  class="select-input"
                  style="margin-left: 12px;"
                  v-model="editedMeetingInfo.meetingPW"
                />
              </div>
            </div>
          </div>
          <div class="is-ipad" style="height: 50px;"></div>
          <div class="dialog-footer">
            <!-- <button class="dialog-delete" @click="deleteMeeting()">삭제</button> -->
            <button class="dialog-cancelBtn" @click="close">취소</button>
            <button class="dialog-okBtn" @click="editMeeting">수정</button>
          </div>
          <div
            style="color: red; font-size:15px;
    padding: 15px;
    margin-left: 20px;"
            v-if="meetingTypeBtn === 'open'"
          >
            {{
              meetingType !== "conf"
                ? "※ " +
                  meetingTypeTxt +
                  "에서 개설된 영상회의는 제목과 일시 수정이 불가합니다."
                : "※ " +
                  meetingTypeTxt +
                  "에서 개설된 영상회의는 제목과 일시, 회의실 수정이 불가합니다."
            }}
          </div>
        </div>
      </div>
    </v-card>
    <!-- <meeting-type-dialog
      :dialog="meetingTypeDialog.dialog"
      :attendeesInfo="meetingTypeDialog.attendees"
      :close="closeMeetingTypeDialog"
    /> -->
    <meeting-conference-dialog
      :dialog="meetingConferenceDialog.dialog"
      :meetingInfo="editedMeetingInfo"
      :conferenceRooms="editedMeetingInfo.conferenceRooms"
      :closeDialog="closeMeetingConferenceDialog"
      @selectedConferenceRooms="selectedConferenceRooms"
    />

    <meeting-layout-dialog
      :dialog="meetingLayoutDialog.dialog"
      @selectedFixSeatList="selectedFixSeatList"
      :attendees="meetingLayoutDialog.attendees"
      :meeetingFixSeatList="editedMeetingInfo.fixSeatList"
      :selectLayoutCode="editedMeetingInfo.layoutCode"
      :conferenceRoomActive="conferenceRoomActive"
      @closeMeetingLayoutDialog="closeMeetingLayoutDialog"
    />

    <conference-agree-dialog
      :dialog="conferenceAgreeDialog.dialog"
      :closeDialog="closeConferenceAgreeDialog"
    />

    <!-- 회의 불러오기 보기 -->
    <bookmark-meeting-dialog
      :dialog="bookmarkMeetingDialog.dialog"
      @selectedBookmarkMeeting="selectedBookmarkMeeting"
      :closeDialog="closeBookmarkMeetingDialog"
    />

    <!-- 회의 저장 -->
    <add-bookmark-meeting-dialog
      :dialog="addBookmarkMeetingDialog.dialog"
      :meetingInfo="addBookmarkMeetingDialog.meetingInfo"
      :closeDialog="closeAddBookmarkMeetingDialog"
    />
    <tb-meeting-invitaion-dialog
      :dialog="meetingInvitaionDialog.dialog"
      :attendeesInfo="meetingInvitaionDialog.attendees"
      :closeMeetingInvitaionDialog="closeMeetingInvitaionDialog"
    />
    <!-- 안내문구 -->
    <guide-log-dialog
      :dialog="guideLogDialog.dialog"
      :guideContents="guideLogContents"
      :closeDialog="closeGuideLogDialog"
    />

    <!-- 녹화문구 -->
    <rec-log-dialog
      :dialog="recLogDialog.dialog"
      :recContents="recLogContents"
      :closeDialog="closeRecLogDialog"
    />

    <delete-confirm-dialog
      :dialog="deleteConfirmDialog.dialog"
      :status="meetingInfo.status"
      :meeting="meetingInfo"
      :checkDelClose="checkDelClose"
      :closeDialog="closeAddBookmarkMeetingDialog"
      :closeDeleteConfirmDialog="closeDeleteConfirmDialog"
    ></delete-confirm-dialog>
  </v-dialog>
</template>
<script>
import Util from "@/util";

import MeetingCreate from "@/components/meeting/MeetingCreate";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
/* import MeetingTypeDialog from '@/components/popup/MeetingTypeDialog'; */
import MeetingConferenceDialog from "@/components/popup/MeetingConferenceDialog";
import moment from "moment";
import timezone from "moment-timezone";
import TbMeetingInvitaionDialog from "@/components/popup/TbMeetingInvitaionDialog";
import BookmarkMeetingDialog from "@/components/popup/BookmarkMeetingDialog";
import AddBookmarkMeetingDialog from "@/components/popup/AddBookmarkMeetingDialog";
import GuideLogDialog from "@/components/popup/GuideLogDialog";
import RecLogDialog from "@/components/popup/RecLogDialog";
import MeetingLayoutDialog from "@/components/popup/MeetingLayoutDialog";
import ConferenceAgreeDialog from "@/components/popup/ConferenceAgreeDialog";
import DeleteConfirmDialog from "@/components/popup/DeleteConfirmDialog";
export default {
  filters: {
    conferenceDayFilter: function(day) {
      if (day === null) {
        return moment().format("YYYY / MM / DD");
      } else {
        return moment(day).format("YYYY / MM / DD");
      }
    },
    conferenceTimeFilter: function(time) {
      return moment(time).format("HH시 mm분");
    },
    textLengthOverCut(txt, len, lastTxt) {
      if (len === "" || len === null) {
        len = 5;
      }
      if (lastTxt === "" || lastTxt === null) {
        lastTxt = "...";
      }
      console.log(txt.length);
      console.log(len);
      if (txt.length > len) {
        txt = txt.substr(0, len) + lastTxt;
        console.log(txt);
      }
      return txt;
    },
  },
  components: {
    MeetingCreate,
    /* MeetingTypeDialog, */
    MeetingConferenceDialog,
    TbMeetingInvitaionDialog,
    MeetingLayoutDialog,
    BookmarkMeetingDialog,
    AddBookmarkMeetingDialog,
    ConferenceAgreeDialog,
    GuideLogDialog,
    RecLogDialog,
    DatePicker,
    DeleteConfirmDialog,
  },
  props: [
    "dialog",
    "closeDialog",
    "meetingInfo",
    "isTimeFixed",
    "isRoomSelectable",
    "isAdminPage",
    "mode",
  ],
  data() {
    return {
      meetingTypeFixed: false,
      isDeleteConf: false,
      checkDelClose: "del",
      deleteConfirmDialog: {
        dialog: false,
      },
      lang: {
        days: ["일", "월", "화", "수", "목", "금", "토"],
        months: [
          "1월",
          "2월",
          "3월",
          "4월",
          "5월",
          "6월",
          "7월",
          "8월",
          "9월",
          "10월",
          "11월",
          "12월",
        ],
        yearFormat: "YYYY년",
        monthFormat: "MM월",
        // the calendar title of month before year
        monthBeforeYear: false,
      },
      pickrFormat: "YYYY/MM/DD",
      allPublicMeeting: false,
      max: 4,
      minDate: new Date().toISOString().substr(0, 10),
      startDate: new Date().toISOString().substr(0, 10),
      isHelpActive: "none",
      startTime: null,
      endTime: null,
      loading: true,
      attendeesString: null,
      selectedConferenceRoomString: null,
      meetingBookmarkImage: "/static/seoul/img/bookmark_off.png",
      meetingBookmarkActive: false,
      meetingLogActive: false,
      meetingTypeDialog: {
        dialog: false,
        attendees: [],
      },
      meetingConferenceDialog: {
        dialog: false,
        conferenceRooms: [],
      },
      meetingLayoutDialog: {
        dialog: false,
        attendees: [],
        fixSeatList: [],
        selectLayoutCode: null,
      },
      meetingInvitaionDialog: {
        dialog: false,
        attendees: [],
        notice: {
          email: true,
          kakao: false,
        },
      },
      conferenceAgreeDialog: {
        dialog: false,
      },
      bookmarkMeetingDialog: {
        dialog: false,
      },
      addBookmarkMeetingDialog: {
        dialog: false,
        meetingInfo: {},
      },
      guideLogDialog: {
        dialog: false,
      },
      recLogDialog: {
        dialog: false,
      },
      addBookmarkMeetingBtn: false,
      layoutFixSeatList: {
        selectedLayoutCode: null,
        selectedLayoutImage: null,
        fixSeatList: [],
      },
      isPrivate: "",
      meetingType: null,
      meetingTypeTxt: "일반",
      conferenceRoomActive: false,
      meetingPublicType: false,
      isActive: "none",
      isRoomActive: "none",
      isActiveStartTime: "none",
      isInputLayout: "",
      isLayout: "none",
      guideLog: null,
      recLog: null,
      exMeeting: false,
      meetingLog: null,
      agreeConference: null,
      meetingBanner: false,
      bannerPosition: "bannerTop",
      meetingBannerActive: "none",
      defaultMeeting: {
        email: null,
        title: null,
        startTime: null,
        endTime: null,
        startDtime: null,
        endDtime: null,
        attendees: [],
        meetingRoom: null,
        meetingRoomId: null,
        roomIds: [],
        password: null,
        notice: {
          email: true,
          kakao: true,
        },
      },
      editedMeetingInfo: {},
      meeting: {
        email: null,
        title: null,
        startTime: null,
        endTime: null,
        startDtime: null,
        endDtime: null,
        attendees: [],
        roomIds: [],
        password: null,
        notice: {
          email: true,
          kakao: true,
        },
      },
      error: null,
      immediateMeeting: false,
      repeatSetting: false,
      meetingTimeList: [],
      selectedConferenceRoom: null,
      selectedConferenceRoomArr: [],
      guideLogContents: null,
      recLogContents: null,
      meetingTypeText: "개설",
      disabledBackground: "#f3f3f3",
      disabledColor: "#b8b8b8",
      meetingTypeBtn: "open",
    };
  },
  computed: {
    nowHour() {
      let hh = moment().format("HH");
      let mm = moment().format("mm");

      let setHour = "";

      if (mm < 30) {
        setHour = moment().format("YYYY-MM-DDTHH:mm:ss");
      } else {
        setHour = moment()
          .add("1", "h")
          .format("YYYY-MM-DDTHH:00:00");
      }

      return setHour;
    },
    reserveHour() {
      let time = this.meeting.startTime;
      if (time !== null) {
        if (time !== "") {
          let hh = time.split("T")[1].split(":")[0];
          let mm = time
            .split("T")[1]
            .split(":")[1]
            .split(":")[0];

          let setHour = "";
          if (mm === 30) {
            hh = parseInt(hh, 10) + 1;
            setHour = moment().format("YYYY-MM-DDT" + hh + ":00:ss");
          } else {
            setHour = moment()
              .add("30", "m")
              .format("YYYY-MM-DDT" + hh + ":30:ss");
          }

          return setHour;
        }
      }
    },
    getMaxDateTime() {
      return null;
    },
  },
  watch: {
    dialog: {
      handler(val) {
        if (val) {
          this.isDeleteConf = false;
          this.defaultMeeting = Object.assign({}, this.meetingInfo);
          this.editedMeetingInfo = Object.assign({}, this.meetingInfo);

          // 비밀번호
          if (
            this.editedMeetingInfo.meetingPW === null ||
            this.editedMeetingInfo.meetingPW === ""
          ) {
            this.meetingPublicType = false;
            this.isPrivate = "none";
          } else {
            this.meetingPublicType = true;
            this.editedMeetingInfo.meetingPW = decodeURI(
              decodeURIComponent(this.editedMeetingInfo.meetingPW)
            )
              .replace("스마트", "")
              .replace("회의", "");
          }

          // 시간 설정
          this.editedMeetingInfo.startTime = moment(
            this.editedMeetingInfo.startDtime
          )
            .utc()
            .format("HH:mm");
          this.editedMeetingInfo.endTime = moment(
            this.editedMeetingInfo.endDtime
          )
            .utc()
            .format("HH:mm");
          this.loading = false;
          this.initMeeting();

          // attendeeString
          this.getAttendeesString(this.editedMeetingInfo.attendees);

          if (!this.editedMeetingInfo.layoutCode) {
            this.isInputLayout = "";
            this.isLayout = "none";
          } else {
            this.isInputLayout = "none";
            this.isLayout = "";
          }
          this.layoutFixSeatList.selectedLayoutImage = this.editedMeetingInfo.layoutImage;
          this.layoutFixSeatList.selectedLayoutCode = this.editedMeetingInfo.layoutCode;
          this.layoutFixSeatList.fixSeatList = this.editedMeetingInfo.fixSeatList;

          this.meetingLayoutDialog.attendees = this.editedMeetingInfo.attendees;
          this.meetingLayoutDialog.fixSeatList = this.editedMeetingInfo.fixSeatList;
          this.meetingLayoutDialog.selectedLayoutCode = this.editedMeetingInfo.layoutCode;

          this.startDate = moment(
            this.editedMeetingInfo.selectStartTime
          ).format("YYYY.MM.DD");
        }
      },
    },
    guideLog() {
      if (this.guideLog === true) {
        this.guideLogDialog.dialog = true;
      } else {
        this.guideLogDialog.dialog = false;
      }
    },
    recLog() {
      if (this.recLog === true) {
        this.recLogDialog.dialog = true;
      } else {
        this.recLogDialog.dialog = false;
      }
    },

    conferenceRoomActive() {
      this.meetingLog = false;

      if (this.conferenceRoomActive === true) {
        this.isRoomActive = "";
        this.meetingLayoutDialog.selectLayoutCode = null;
        this.layoutFixSeatList.selectedLayoutImage = null;
        this.isInputLayout = "";
        this.isLayout = "none";
        // this.conferenceAgreeDialog.dialog = true;
      } else {
        this.isRoomActive = "none";
        this.meetingLayoutDialog.selectLayoutCode = null;
        this.layoutFixSeatList.selectedLayoutImage = null;
        this.isInputLayout = "";
        this.isLayout = "none";
        // this.conferenceAgreeDialog.dialog = false;
        this.meetingConferenceDialog.conferenceRooms = [];
      }
    },
    meetingPublicType() {
      if (this.meetingPublicType === true) {
        this.isPrivate = "";
      } else {
        this.isPrivate = "none";
      }
    },
    immediateMeeting: function(val) {
      /* 즉시회의 여기서 작업하시면 됩니다. */
      this.isTimeFixed = true;
      this.immediateChange(val);
      this.editedMeetingInfo.selectStartTime = moment().format("YYYY/MM/DD");
    },
    meetingBanner() {
      this.meetingBanner
        ? (this.meetingBannerActive = "")
        : (this.meetingBannerActive = "none");
    },
  },
  mounted() {},
  methods: {
    prepareService() {
      alert("준비중인 서비스입니다.");
    },
    notBeforeToday(date) {
      return date < new Date(new Date().setHours(0, 0, 0, 0));
    },
    initMeeting() {
      if (this.editedMeetingInfo.meetingType !== null) {
        this.meetingTypeFixed = true;
      }
      $("input[class=mx-input]").attr("readonly", true);
      this.editedMeetingInfo.startDate = moment(
        this.editedMeetingInfo.startDtime
      )
        .utc()
        .format("YYYY/MM/DD");
      this.editedMeetingInfo.selectStartTime = moment(
        this.editedMeetingInfo.startDtime
      )
        .utc()
        .format("YYYY/MM/DD");
      this.initTimeData();

      let meetingType = this.editedMeetingInfo.meetingType;

      // 스마트회의 일반회의 => 포털에서 수정 클릭 시

      if (meetingType) {
        if (meetingType === "video" || meetingType === "portal") {
          this.disabledBackground = "white";
          this.disabledColor = "#555";
          this.meetingTypeFixed = false;
          this.isTimeFixed = false;
          this.isEdit = "edit";
          this.meetingTypeBtn = "noOpen";
        } else {
          console.log(`meetingType : `, meetingType);
          this.meetingTypeFixed = true;
          this.isEdit = "edit";
          this.meetingTypeBtn = "open";
          if (meetingType === "cooperation") {
            this.meetingTypeTxt = "협업공간";
          } else if (meetingType === "planner") {
            this.meetingTypeTxt = "플래너";
          } else if (meetingType === "flow") {
            this.meetingTypeTxt = "협업공간";
          } else if (meetingType === "report") {
            this.meetingTypeTxt = "보고/회의";
          } else if (meetingType === "portal") {
            this.meetingTypeFixed = false;
          } else if (meetingType === "conf") {
            this.meetingTypeTxt = "차량/회의실";
          }
        }
        this.meetingType = this.editedMeetingInfo.meetingType;
      } else {
        this.disabledBackground = "white";
        this.disabledColor = "#555";
        this.meetingTypeFixed = false;
        this.isTimeFixed = false;
        this.meetingTypeBtn = "noOpen";
        meetingType = "portal";
      }
      if (this.editedMeetingInfo.conferenceRoomActive === true) {
        this.conferenceRoomActive = this.editedMeetingInfo.conferenceRoomActive;
        this.isRoomActive = "";
        if (this.editedMeetingInfo.conferenceRooms.length > 1) {
          this.selectedConferenceRoomString =
            this.editedMeetingInfo.conferenceRooms[0].deviceName +
            "외 " +
            parseInt(this.editedMeetingInfo.conferenceRooms.length - 1) +
            "곳";
        } else {
          if (this.editedMeetingInfo.conferenceRooms.length !== 0) {
            this.selectedConferenceRoomString = this.editedMeetingInfo.conferenceRooms[0].deviceName;
          }
        }
        // this.conferenceAgreeDialog.dialog = true;
      } else {
        this.isRoomActive = "none";
        this.meetingConferenceDialog.conferenceRooms = [];
      }
    },

    initTimeData() {
      this.meetingTimeList = [];
      let meetingInterval = 10;
      let time = moment();
      let staDate = moment(time.format("YYYY/MM/DD"));
      let endDate = time
        .clone()
        .add(1, "day")
        .format("YYYY/MM/DD");
      for (
        let now = new Date(),
          start = new Date(now.setHours(0, 0, 0, 0)),
          end = new Date(now.setDate(now.getDate() + 1));
        start < end;
        start.setMinutes(start.getMinutes() + 10)
      ) {
        this.meetingTimeList.push(start.toTimeString().slice(0, 5));
        //console.log(start.toTimeString().slice(0, 5));
      }

      // 초기 시간 선택
      if (
        this.meetingInfo.selectStartTime !== null &&
        this.meetingInfo.selectEndTime
      ) {
        this.meeting.startTime = this.meetingInfo.selectStartTime;
        this.meeting.endTime = this.meetingInfo.selectEndTime;
        this.startTime = moment(this.meeting.startTime).format("HH:mm");
        this.endTime = moment(this.meeting.endTime).format("HH:mm");
      } else {
        let nearestFuture = Util.nearestFutureMinutes(meetingInterval, time);
        if (this.immediateMeeting) {
          this.editedMeetingInfo.startTime = this.$t(
            "page.meeting-reserve.immediate"
          );
        } else {
          this.editedMeetingInfo.startTime = moment(this.meetingInfo.startDtime)
            .utc()
            .format("HH:mm");
        }
        this.endTime = nearestFuture.add(30, "minutes").format("HH:mm");
      }

      this.meeting.startTime = moment
        .tz(this.startDate + " " + this.startTime, moment.tz.guess())
        .utc()
        .format();
      this.meeting.endTime = moment
        .tz(this.startDate + " " + this.endTime, moment.tz.guess())
        .utc()
        .format();
    },
    openMeetingTypeDialog() {
      /* 미팅 유형 선택 팝업 */
      this.meetingTypeDialog.dialog = true;
    },
    openMeetingConferenceDialog() {
      let startDtime = moment
        .tz(
          this.startDate + " " + this.editedMeetingInfo.startTime,
          moment.tz.guess()
        )
        .utc()
        .format();
      let endDtime = moment
        .tz(
          this.startDate + " " + this.editedMeetingInfo.endTime,
          moment.tz.guess()
        )
        .utc()
        .format();

      this.editedMeetingInfo.startDtime = startDtime;
      this.editedMeetingInfo.endDtime = endDtime;

      if (
        this.defaultMeeting.startDtime !== this.editedMeetingInfo.startDtime ||
        this.defaultMeeting.endDtime !== this.editedMeetingInfo.endDtime
      ) {
        if (
          confirm(
            "기존에 예약한 회의실 일정과 다릅니다. 기존 예약을 취소하고 새로 예약하시겠습니까?"
          )
        ) {
          this.$http
            .delete("/api/v1/meetings/deleteKrxConf", {
              params: this.editedMeetingInfo,
            })
            .then(response => {
              let ret = response.data;
              this.editedMeetingInfo.conferenceRooms = [];
              this.meetingConferenceDialog.dialog = true;
              this.isDeleteConf = true;
            })
            .catch(error => {
              console.log(`error`, error);
              this.error = error.response.data.error;
            });
          return false;
        }
      }
      this.meetingConferenceDialog.dialog = true;
      this.meetingConferenceDialog.conferenceRooms = this.editedMeetingInfo.conferenceRooms;
    },
    closeMeetingConferenceDialog() {
      this.meetingConferenceDialog.dialog = false;
    },
    closeConferenceAgreeDialog() {
      this.conferenceAgreeDialog.dialog = false;
    },
    close() {
      this.$emit("editedMeeting");
      this.conferenceRoomActive = false;
      this.editedMeetingInfo = {};
      this.attendeesString = null;
      this.selectedConferenceRoomString = null;
    },
    showDatePicker() {
      if (!this.editedMeetingInfo.isImmediately) {
        if (this.isActive === "none") {
          this.isActive = "";
        } else {
          this.isActive = "none";
        }
      }
    },
    startDateChange() {
      this.isActive = "none";
      this.editedMeetingInfo.selectStartTime = this.editedMeetingInfo.startDate;
    },
    showStartTimePicker() {
      if (this.isActiveStartTime === "none") {
        this.isActiveStartTime = "";
      } else {
        this.isActiveStartTime = "none";
      }
    },
    changedstartTime() {
      console.log(`changedstartTime`);
    },
    changedendTime() {
      console.log(`changedendTime`);
    },
    editMeeting() {
      if (this.editedMeetingInfo.startTime === "즉시회의") {
        this.editedMeetingInfo.startTime = moment(new Date()).format("HH:mm");
        this.editedMeetingInfo.status = "s";
      }
      this.editedMeetingInfo.startDtime = moment
        .tz(
          this.editedMeetingInfo.startDate +
            " " +
            this.editedMeetingInfo.startTime,
          moment.tz.guess()
        )
        .utc()
        .format();
      this.editedMeetingInfo.endDtime = moment
        .tz(
          this.editedMeetingInfo.startDate +
            " " +
            this.editedMeetingInfo.endTime,
          moment.tz.guess()
        )
        .utc()
        .format();

      if (
        this.editedMeetingInfo.startDtime >= this.editedMeetingInfo.endDtime &&
        !this.immediateMeeting
      ) {
        if (
          this.editedMeetingInfo.startDtime === this.editedMeetingInfo.endDtime
        ) {
          Util.snackBarOpen(
            "시작일시와 종료일시가 같을 수 없습니다. 정확한 정보를 입력해주세요",
            "error"
          );
          return;
        } else {
          Util.snackBarOpen(
            "시작일시가 종료일시보다 늦습니다. 정확한 정보를 입력해주세요",
            "error"
          );
          this.error =
            "시작일시가 종료일시보다 늦습니다. 정확한 정보를 입력해주세요";
          return;
        }
      }

      if (this.conferenceRoomActive === true) {
        if (this.editedMeetingInfo.conferenceRooms === null) {
          Util.snackBarOpen("영상회의실을 추가해주세요", "error");
          return;
        } else {
          if (this.editedMeetingInfo.conferenceRooms.length === 0) {
            Util.snackBarOpen("영상회의실을 추가해주세요", "error");
            return;
          }
        }
      }

      if (
        moment(new Date()).format("YYYY/MM/DD") ===
          this.editedMeetingInfo.startDate &&
        moment(new Date()).format("HH:mm") >=
          this.editedMeetingInfo.startTime &&
        !this.immediateMeeting
      ) {
        Util.snackBarOpen(
          "지난 시간입니다. 현재 시간 이후로 예약이 가능합니다.",
          "error"
        );
        return;
      }
      if (this.meetingPublicType === true) {
        if (
          this.editedMeetingInfo.meetingPW === null ||
          this.editedMeetingInfo.meetingPW === ""
        ) {
          Util.snackBarOpen("비밀번호를 입력하시기 바랍니다.", "error");
          return;
        }
      } else {
        this.editedMeetingInfo.meetingPW = null;
      }
      let now = moment()
        .utc()
        .format();
      if (now >= this.editedMeetingInfo.endDtime && this.immediateMeeting) {
        Util.snackBarOpen("예약시간 오류", "error");
        return;
      }

      //#############  +9시간이 안돼서 갑자기 추가하게 됨 (추후 변경)
      let insertStartDtime = moment(this.editedMeetingInfo.startDtime).format(
        "YYYY-MM-DD HH:mm"
      );

      let insertEndDtime = moment(this.editedMeetingInfo.endDtime).format(
        "YYYY-MM-DD HH:mm"
      );

      this.editedMeetingInfo.startDtime =
        new Date(insertStartDtime).toISOString().split(".")[0] + "Z";
      this.editedMeetingInfo.endDtime =
        new Date(insertEndDtime).toISOString().split(".")[0] + "Z";

      this.editedMeetingInfo.conferenceRoomActive = this.conferenceRoomActive;
      this.editedMeetingInfo.fixSeatList = this.layoutFixSeatList.fixSeatList;
      this.editedMeetingInfo.layoutCode = this.layoutFixSeatList.selectedLayoutCode;
      this.editedMeetingInfo.layoutImage = this.layoutFixSeatList.selectedLayoutImage;

      let layoutCode = "";
      let fixSeatList = "";
      let openOption = "";
      let pwdCode = "";
      let guideApi = "";
      let recApi = "";

      let saehaLayoutCode = "";
      if (this.editedMeetingInfo.layoutCode !== null) {
        switch (this.editedMeetingInfo.layoutCode) {
          case "lay1":
            saehaLayoutCode = "4";
            break;
          case "lay2":
            saehaLayoutCode = "6";
            break;
          case "lay3":
            saehaLayoutCode = "7";
            break;
          case "lay4":
            saehaLayoutCode = "8";
            break;
          case "lay5":
            saehaLayoutCode = "9";
            break;
          case "lay6":
            saehaLayoutCode = "10";
            break;
          case "lay7":
            saehaLayoutCode = "11";
            break;
          case "lay8":
            saehaLayoutCode = "13";
            break;
          case "lay9":
            saehaLayoutCode = "14";
            break;
          case "lay10":
            saehaLayoutCode = "15";
            break;
          case "lay11":
            saehaLayoutCode = "18";
            break;
          case "lay12":
            saehaLayoutCode = "19";
            break;
          case "lay13":
            saehaLayoutCode = "20";
            break;
          case "lay14":
            saehaLayoutCode = "22";
            break;
        }
        layoutCode = "12849=0," + saehaLayoutCode;

        if (
          this.layoutFixSeatList.fixSeatList &&
          this.layoutFixSeatList.fixSeatList.length > 0
        ) {
          fixSeatList += "12888=";

          let seats = this.layoutFixSeatList.fixSeatList
            .filter(fixSeat => fixSeat.seat !== null)
            .map(fixSeat => {
              return (
                "0," +
                (fixSeat.id - 1) +
                ",0," +
                fixSeat.seat.split("_")[0] +
                "," +
                fixSeat.seat.split("_")[1]
              );
            });
          console.log(seats);
          fixSeatList += seats.join("|");
          openOption = layoutCode + "&" + fixSeatList;
        } else {
          openOption = layoutCode;
        }
      }
      this.editedMeetingInfo.roomOption = openOption;

      if (this.editedMeetingInfo.conferenceRoomActive === true) {
        // 고화질 영상회의인 경우
        if (
          this.defaultMeeting.startDtime !==
            this.editedMeetingInfo.startDtime ||
          this.defaultMeeting.endDtime !== this.editedMeetingInfo.endDtime
        ) {
          if (!this.isDeleteConf) {
            // 기존 시작 시간이 다를 경우
            if (
              confirm(
                "기존에 예약한 회의실 일정과 다릅니다. 기존 예약을 취소하고 새로 예약하시겠습니까?"
              )
            ) {
              this.$http
                .delete("/api/v1/meetings/deleteKrxConf", {
                  params: this.editedMeetingInfo,
                })
                .then(response => {
                  let ret = response.data;
                  this.editedMeetingInfo.conferenceRooms = [];
                  this.meetingConferenceDialog.dialog = true;
                  this.isDeleteConf = true;
                })
                .catch(error => {
                  console.log(`error`, error);
                  this.error = error.response.data.error;
                });
              return false;
            }
          } else {
            this.$http
              .put("/api/v1/meetings/editKrxMeeting", this.editedMeetingInfo)
              .then(response => {
                let ret = response.data[0];

                console.log(ret);
                Util.snackBarOpen("영상회의 수정 완료", "success");
                this.immediateMeeting = false;
                this.close();
              })
              .catch(error => {
                console.log(`error`, error);
                this.error = error.response.data.error;
              });
          }
        } else {
          this.$http
            .put("/api/v1/meetings/editKrxMeeting", this.editedMeetingInfo)
            .then(response => {
              let ret = response.data[0];

              console.log(ret);
              Util.snackBarOpen("영상회의 수정 완료", "success");
              this.immediateMeeting = false;
              this.close();
            })
            .catch(error => {
              console.log(`error`, error);
              this.error = error.response.data.error;
            });
        }
      } else {
        this.$http
          .put("/api/v1/meetings/editKrxMeeting", this.editedMeetingInfo)
          .then(response => {
            let ret = response.data[0];

            console.log(ret);
            Util.snackBarOpen("영상회의 수정 완료", "success");
            this.immediateMeeting = false;
            this.close();
          })
          .catch(error => {
            console.log(`error`, error);
            this.error = error.response.data.error;
          });
      }
    },
    async deleteMeeting() {
      this.deleteConfirmDialog.dialog = true;
      this.checkDelClose = "del";
      let params = {
        meetingKey: this.editedMeetingInfo.meetingKey,
        meetingType: this.editedMeetingInfo.meetingType,
        creator: this.editedMeetingInfo.creator,
        email: this.editedMeetingInfo.creator.email,
      };
      await this.$http
        .delete("/api/v1/meetings/deleteKrxMeeting", { params: params })
        .then(response => {
          if (response.data.fail) {
            alert("차량/회의실 연동 오류 - 스마트회의 내 영상회의실 삭제 완료");
            this.close();
          } else {
            Util.snackBarOpen("영상회의 삭제 완료", "success");
            this.close();
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    selectedConferenceRooms(selectedConferenceRooms) {
      let rooms = "";
      this.selectedConferenceRoomArr = [];
      if (selectedConferenceRooms.length !== 0) {
        this.editedMeetingInfo.conferenceRooms = selectedConferenceRooms;
        for (let i = 0; i < selectedConferenceRooms.length; i++) {
          this.meeting.roomIds.push(selectedConferenceRooms[i]._id);
          if (i === selectedConferenceRooms.length - 1) {
            rooms += selectedConferenceRooms[i].deviceName;
          } else {
            rooms += selectedConferenceRooms[i].deviceName + ", ";
          }
          this.selectedConferenceRoomArr.push(selectedConferenceRooms[i]);
        }
        if (this.selectedConferenceRoomArr.length > 1) {
          this.selectedConferenceRoomString =
            this.selectedConferenceRoomArr[0].deviceName +
            "외 " +
            parseInt(this.selectedConferenceRoomArr.length - 1) +
            "곳";
        } else {
          this.selectedConferenceRoomString = this.selectedConferenceRoomArr[0].deviceName;
        }
      } else {
        this.editedMeetingInfo.conferenceRooms = [];
        this.selectedConferenceRoomString = null;
      }
    },
    immediateChange(immediate) {
      this.isActive = "none";
      if (immediate) {
        // 시작 시간 => 즉시로 변경
        // 시작 날짜 => 오늘로 변경
        this.meetingTimeList.unshift(this.$t("page.meeting-reserve.immediate"));
        this.editedMeetingInfo.startTime = this.meetingTimeList[0];
        console.log(`?? : `, this.meetingTimeList);
        this.editedMeetingInfo.startDate = moment().format("YYYY/MM/DD");
        this.editedMeetingInfo.startDate = moment().format("YYYY/MM/DD");

        let meetingInterval = 10;
        let time = moment();
        let nearestFuture = Util.nearestFutureMinutes(meetingInterval, time);
        this.endTime = nearestFuture.add(30, "minutes").format("HH:mm");
      } else {
        this.initTimeData();
        this.isTimeFixed = false;
      }
    },
    deleteConferenceRoom(index) {
      this.selectedConferenceRoomArr.splice(index, 1);
    },
    changeMeetingType() {
      if (this.meetingType === "general") {
        this.meetingType = "general";
        this.attendeesString = this.$t("page.meeting-reserve.attendee-list");
      } else {
        this.meetingType = "article";
        this.attendeesString = this.$t(
          "page.meeting-reserve.attendee-list-type2"
        );
      }
    },
    openBookmarkMeetingDialog() {
      this.bookmarkMeetingDialog.dialog = true;
    },
    closeBookmarkMeetingDialog() {
      this.bookmarkMeetingDialog.dialog = false;
    },
    openAddBookmarkMeetingDialog() {
      let layoutCode = "";
      let fixSeatList = "";
      let pwdCode = "";

      // if (this.meeting.password !== null) {
      //   pwdCode = '8208=' + this.meeting.password + '&';
      // }

      if (this.layoutFixSeatList.selectedLayoutCode !== null) {
        layoutCode =
          "4192=0," +
          this.layoutFixSeatList.selectedLayoutCode.replace("lay", "") +
          ",0&";
        fixSeatList = "";

        if (
          this.layoutFixSeatList.fixSeatList &&
          this.layoutFixSeatList.fixSeatList.length > 0
        ) {
          fixSeatList += "8304=";
          const seats = this.layoutFixSeatList.fixSeatList
            .filter(fixSeat => fixSeat.seat !== null)
            .map(fixSeat => {
              return (
                fixSeat.id +
                ",1," +
                fixSeat.seat.split("_")[0] +
                "," +
                fixSeat.seat.split("_")[1]
              );
            });
          fixSeatList += seats.join("|");
        }
      }
      let roomOption = pwdCode + layoutCode + fixSeatList;

      let meetingInfo = {
        creator: {
          email: this.meeting.email,
        },
        title: this.meeting.title,
        startDtime: this.meeting.startDtime, // (new Date(this.meeting.startTime)).toISOString().split('.')[0] + 'Z',
        endDtime: this.meeting.endDtime, // (new Date(this.meeting.endTime)).toISOString().split('.')[0] + 'Z',
        attendees: this.meeting.attendees,
        password: this.meeting.password,
        isImmediately: this.immediateMeeting,
        conferenceRoomActive: this.conferenceRoomActive,
        selectedConferenceRoomArr: this.selectedConferenceRoomArr,
        layoutFixSeatList: this.layoutFixSeatList,
        meetingLog: this.meetingLog,
        roomOption: roomOption,
      };

      this.addBookmarkMeetingDialog.dialog = true;
      this.addBookmarkMeetingDialog.meetingInfo = meetingInfo;
    },
    closeAddBookmarkMeetingDialog() {
      this.addBookmarkMeetingDialog.dialog = false;
    },
    closeGuideLogDialog(contents) {
      if (contents) {
        this.guideLogContents = contents;
      } else {
        // 취소
        this.guideLogContents = contents;
        this.guideLog = false;
      }
      this.guideLogDialog.dialog = false;
    },
    closeRecLogDialog(contents) {
      if (contents) {
        this.recLogContents = contents;
      } else {
        // 취소
        this.recLogContents = contents;
        this.recLog = false;
      }
      this.recLogDialog.dialog = false;
    },
    openMeetingInvitaionDialog() {
      this.meetingInvitaionDialog.dialog = true;
      this.meetingInvitaionDialog.attendees = this.editedMeetingInfo.attendees;
    },
    getAttendeesString(attendees) {
      if (attendees) {
        if (attendees.length === 1) {
          if (attendees[0].name) {
            this.attendeesString = `${attendees[0].name}`;
          } else {
            this.attendeesString = `${attendees[0].email}`;
          }
        } else if (attendees.length > 1) {
          if (attendees[0].name) {
            this.attendeesString = `${attendees[0].name} 외 ${attendees.length -
              1}명`;
          } else {
            this.attendeesString = `${
              attendees[0].email
            } 외 ${attendees.length - 1}명`;
          }
        } else if (attendees.length === 0) {
          this.attendeesString = null;
        }
      }
    },
    closeMeetingInvitaionDialog(attendees, exMeeting) {
      if (attendees) {
        if (attendees.length === 1) {
          if (attendees[0].name) {
            this.attendeesString = `${attendees[0].name}`;
          } else if (attendees[0].email) {
            this.attendeesString = `${attendees[0].email}`;
          } else {
            this.attendeesString = `${attendees[0].phone}`;
          }
        } else if (attendees.length > 1) {
          if (attendees[0].name) {
            this.attendeesString = `${attendees[0].name} 외 ${attendees.length -
              1}명`;
          } else if (attendees[0].email) {
            this.attendeesString = `${
              attendees[0].email
            } 외 ${attendees.length - 1}명`;
          } else {
            this.attendeesString = `${
              attendees[0].phone
            } 외 ${attendees.length - 1}명`;
          }
        } else if (attendees.length === 0) {
          this.attendeesString = null;
        }

        this.meetingInvitaionDialog.dialog = false;
        this.editedMeetingInfo.attendees = attendees;
        this.meeting.exMeeting = exMeeting;
      } else {
        this.meetingInvitaionDialog.dialog = false;
        this.editedMeetingInfo.attendees = attendees;
        this.meeting.attendees = attendees;
      }
    },
    openMeetingLayoutDialog() {
      /* 레이아웃 설정 */
      this.meetingLayoutDialog.attendees = this.editedMeetingInfo.attendees;
      this.meetingLayoutDialog.fixSeatList = this.editedMeetingInfo.fixSeatList;

      if (
        this.conferenceRoomActive &&
        this.editedMeetingInfo.conferenceRooms.length >= 1
      ) {
        if (this.editedMeetingInfo.conferenceRooms[0] === undefined) {
          alert("영상회의실을 추가해주세요");
          return;
        }
        let concatData = this.editedMeetingInfo.conferenceRooms.map(c => {
          return {
            email: c._id,
            name: c.name ? c.name : c.deviceName,
          };
        });
        this.meetingLayoutDialog.attendees = [];

        this.meetingLayoutDialog.attendees = this.meetingLayoutDialog.attendees.concat(
          concatData
        );
      }
      this.meetingLayoutDialog.dialog = true;
    },
    closeMeetingLayoutDialog() {
      this.meetingLayoutDialog.dialog = false;
    },
    selectedFixSeatList(selectedLayoutCode, selectedLayoutImage, fixSeatList) {
      /* @emit function */
      let fixSeatCount = 0;
      for (let k = 0; k < fixSeatList.length; k++) {
        if (fixSeatList[k].seat !== null) {
          console.log(fixSeatList[k].seat);
          fixSeatCount++;
        }
      }

      this.isLayout = "";
      this.isInputLayout = "none";
      this.layoutFixSeatList.selectedLayoutCode = selectedLayoutCode;
      this.layoutFixSeatList.selectedLayoutImage = selectedLayoutImage;

      if (fixSeatCount > 0) {
        this.layoutFixSeatList.fixSeatList = fixSeatList;
      }
      this.meetingLayoutDialog.selectLayoutCode = selectedLayoutCode;
      if (this.layoutFixSeatList.selectedLayoutCode === null) {
        this.isInputLayout = "";
        this.isLayout = "none";
      }
      this.closeMeetingLayoutDialog();
    },
    selectMeetingBookmark() {
      if (this.meetingBookmarkActive === false) {
        this.meetingBookmarkActive = true;
        this.meetingBookmarkImage = "/static/seoul/img/bookmark_on.png";
      } else {
        this.meetingBookmarkActive = false;
        this.meetingBookmarkImage = "/static/seoul/img/bookmark_off.png";
      }
    },
    selectedBookmarkMeeting(meeting) {
      console.log(meeting);
      /* 회의 제목 */
      this.meeting.title = meeting.title;

      /* 공개 비공개 */
      if (meeting.meetingPW === null) {
        this.meetingPublicType = "public";
      } else {
        this.isPrivate = "";
        this.meetingPublicType = "private";
        this.meeting.password = meeting.meetingPW;
      }

      /* 영상회의실 */
      this.conferenceRoomActive = meeting.conferenceRoomActive;

      /* 참석자 */
      this.attendeesString = meeting.attendeesString;
      this.meeting.attendees = meeting.attendees;

      /* 레이아웃 */
      if (meeting.layoutCode === null || meeting.layoutCode === undefined) {
        this.isLayout = "none";
        this.isInputLayout = "";
      } else {
        this.isLayout = "";
        this.isInputLayout = "none";
        this.layoutFixSeatList.layoutCode = meeting.layoutCode;
        this.layoutFixSeatList.selectedLayoutImage = meeting.layoutImage;

        this.meetingLayoutDialog.attendees = meeting.attendees;
        this.layoutFixSeatList.fixSeatList = meeting.fixSeatList;
        this.layoutFixSeatList.selectedLayoutCode = meeting.layoutCode;
        this.meetingLayoutDialog.selectLayoutCode = meeting.layoutCode;
      }

      /* 회의록 */
      this.meetingLog = meeting.meetingLog;
      /* 여기서 작업 */
    },
    openHelpDialog() {
      this.isHelpActive = "";
    },
    closeHelpDialog() {
      this.isHelpActive = "none";
    },
    openDeleteConfirmDialog(txt) {
      this.deleteConfirmDialog.dialog = true;
      this.checkDelClose = txt;
    },
    closeAddBookmarkMeetingDialog() {
      this.addBookmarkMeetingDialog.dialog = false;
      this.deleteConfirmDialog.dialog = false;
    },
    closeDeleteConfirmDialog() {
      let checkDelClose = this.checkDelClose;
      if (checkDelClose === "del") {
        this.deleteMeeting();
      } else {
        this.closeMeeting();
      }
      this.deleteConfirmDialog.dialog = false;
    },
  },
};
</script>
<style scoped lang="stylus">
.pop_top{
  font-weight: 600;
}
.input_meeting{
  border:1px solid #d4d4d4;
  width: 100%;
  vertical-align: middle;
  height: 46px;
  display: inline-block;
  line-height: 2em;
  box-sizing: border-box;
  color: #4e4e4e;
  overflow: hidden;
  text-decoration: none;
  text-indent: 10px;
  border-radius:5px;
}

.datetime-start{
  width: 60%;
  height: 50px;
  border: solid 1px #d4d4d4;
  padding-left: 10px;
  line-height: 50px;
  border-radius: 5px;
  float: left;
}
.datetime-end{
  width: 39%;
  margin-left: 1%;
  height: 50px;
  border: solid 1px #d4d4d4;
  padding-left: 10px;
  line-height: 50px;
  border-radius: 5px;
  float: left;
}

.formbox-time-select{
  width: 24.5%;
  height: 40px;
  font-size: 15px;
  font-weight: 300;
  border: 2px solid #ecedef;
  border-radius: 5px;
  padding-left: 20px;
  margin-left: 0px !important;
  line-height: 35px;

  background-position: 90% 52%;
  background-repeat: no-repeat, no-repeat;

  /* background: url(/static/webex-cloud/images/common/selar.png) no-repeat 87% 52%;
  background: url(/static/webex-cloud/images/common/selar.png) no-repeat 25% 52%; */
}
#startDate1 {
  max-width: 150px;
  margin-right : 15px;
}
.formbox-banner-select{
  width: 65px;
  height: 30px;
  font-size:15px;
  font-weight: 100;
  border: 2px solid #dadada;
  border-radius: 5px;
  padding-left: 7px;
  margin-left: 0px !important;
  line-height: 25px;
  background-image: url(/static/webex-cloud/images/common/selar.png);
  background-position: 87% 52%;
  background-repeat: no-repeat;
}


.select-items {
  position: absolute;
  background-color: DodgerBlue;
  top: 100%;
  left: 0;
  right: 0;
  z-index: 99;
}

.meeting-time{
  border: 1px solid #d4d4d4;
  width : 49%;
  height: 46px;
  float: left;
  text-align: center;
  line-height: 46px;
}

.tbw_p01 .active {
  display: '';
}

.tbw_p01 .noActive {
  display: none;
}

.conferenceroom-btn {
  width: max-content;
  padding-right: 10px;
  height: 30px;
  line-height: 30px;
  margin-top: 5px;
  margin-left: 10px;
  background: #fa4242;
  color: white;
  border-radius: 5px;
  z-index: 5;
  position: relative;
  float: left;
}

.conferenceroom-btn p{
  float: left;
  padding-left: 10px;
}
.conferenceroom-btn img{
  float: left;
  cursor: pointer;
  padding-top: 7px;
  padding-left: 3px;
  width: 8px;
}
.pop_tit{
  height: 20px;
  padding: 30px 0 10px;
  color: #444;
  text-align: left;
  letter-spacing: -1px;
  font-size: 25px;
  text-align: center;
  font-weight: 500;
  line-height: 20px;
  width: 100%;
}
.pop_close{
  position: absolute;
  top: 20px;
  right: 20px;
  display:inline-block;
  width:15px;
  height:15px;
  text-indent: -9999px;
  background: url(/static/webex-cloud/images/common/close_btn.png) center center no-repeat;
}

.popContainer {
  background: #fff;
  font-size: 16px;
  height: 520px;
}

.v-picker{
  position: absolute;
  z-index: 1000;
  top: 45px;
}

.fix-layout-img {
  cursor:pointer;
  margin-left: 25px;
  max-width: 100px;
}

#bookmarkMeeting{
  text-align: center;
  font-size: 11.5pt;
  height: 40px;
  line-height: 40px;
  font-weight: 700;
  float: right;
  background: #cbe9f8;
  color: #2f66aa;
  border-radius: 5px;
}

#bookmarkAddMeeting{
  width: 130px;
  text-align: center;
  padding: 0;
  font-size: 10pt;
  height: 40px;
  line-height: 40px;
  font-weight: 100;
  position: relative;
  top: -43px;
  left: 175px;
}

.help-bg{
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background: black;
  opacity: 0.98;
  z-index: 999;
  overflow: auto;
  text-align: center;
}
.help-img{
  width: 100%;
  max-width: 720px;
  display: inline-block;
  position: relative;
  top: 7%;
}
.close-img{
  position: fixed;
  top: 8%;
  right: 10%;
  cursor: pointer;
  z-index: 1001;
}
input::placeholder{
  color: #bfc3c5;
  padding-left: 5px;
}

:-ms-input-placeholder { /* Internet Explorer 10-11 */
    color: #bfc3c5 !important;
    font-size: 1rem !important;
}

.dialog-container {
  width: 100%;
}


#videoMeetingEditDialog .dialog-container {
  width: 630px;
}

#videoMeetingEditDialog .dialog-header {
  height: 60px;
  line-height: 60px;
}

#videoMeetingEditDialog .header-btn img {
  width: 30px;
}

.is-ipad {
  height: 10px !important;
}

#videoMeetingEditDialog .dialog-title {
  width: 22%;
}

#videoMeetingEditDialog .attendee-row {
  justify-content: start;
}

.dialog-date-contents {
  width: 78%;
  margin-left: 30px;
}

#videoMeetingEditDialog .mx-datepicker {
  width: 110px;
  margin-left: 5px;
  align-items: center;
}

.dialog-hr-line {
  width: 100%;
  margin: 15px 0;
}

.custom-radio:checked {
  background: #31a552;
}

.custom-label:before {
  background-color: white;
}

#organizationChart .popup_tel_wrap {
  display: flex;
  flex-direction: column;
  height: 100%;
}

#organizationChart {
  height: 750px;
}

#organizationChart .dialog-container {
  height: 100%;
}

.orga-container {
  margin: 0 20px;
  margin-bottom: 20px;
}

.orga-step1 {
  border: 1px solid #dddddd;
  width: 45%;
  height: 100%;
  border-radius: 5px;
  padding: 10px;
  overflow: auto;
  max-height: 300px;
}

.orga-step2 {
  width: 70%;
  margin-left: 20px;
  max-height: 300px;
  overflow: auto;
}

.add-orga {
  border: 1px solid #604af3;
  width: calc(100% - 40px);
  margin-left: 20px;
  height: 40px;
  color: #604af3;
  border-radius: 4px;
}

.orga-search_area {
  margin: 10px 20px;
}
.orga-step3 {
  margin: 10px 20px;
}

.orga-selected-member-wrap {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  overflow: auto;
  max-height: 200px;
}
.orga-selected-member {
  display: flex;
  flex-direction: column;
  font-size: 16px;
  margin: 15px;
}

.popup_tel_wrap {
  font-size: 15px !important;
}

#videoMeetingEditDialog .dialog-contents input {
  border: 2px solid #dddddd;
  border-radius: 5px;
  padding: 10px;
  height: 40px;
  width: 100%;
  font-size:15px;
}

#videoMeetingEditDialog .dialog-hr-line {
  margin : 8px 0;
  margin-left: 10px;
}
#videoMeetingEditDialog .dialog-body {
  margin-top: 13px;
}

#videoMeetingEditDialog .select-input {
  height : 40px;
}

#videoMeetingEditDialog .dialog-row {
  min-height: 40px;
}

#videoMeetingEditDialog .dialog-footer {
  padding-bottom: 13px;
}


#tbVideoMeetingCreateDialog .dialog-contents input {
  border: 2px solid #dddddd;
  border-radius: 5px;
  padding: 10px;
  height: 40px;
  width: 100%;
  font-size:15px;
}

#tbVideoMeetingCreateDialog .dialog-hr-line {
  margin : 8px 0;
  margin-left: 10px;
}
#tbVideoMeetingCreateDialog .dialog-body {
  margin-top: 13px;
}

#tbVideoMeetingCreateDialog .select-input {
  height : 40px;
}

#tbVideoMeetingCreateDialog .dialog-row {
  min-height: 40px;
}

#tbVideoMeetingCreateDialog .dialog-footer {
  padding-bottom: 13px;
}

#tbMeetingEditDialog .dialog-title {
  width: 22%;
}
.styled-checkbox:checked + label:after {
  position: absolute;
  left: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/popup/TbEditMeetingDialog.vue